import {createRouter, createWebHistory} from 'vue-router';
import MapView from "@/views/MapView";
import PointCashMapView from "@/views/PointCashMapView";
import NotFoundView from '@/views/NotFoundView';
import MaintenanceView from "@/views/MaintenanceView";


const routes = [
    {
        path: '/map/',
        name: 'map',
        component: MapView,
        meta: {
            title: 'map'
        }
    },
    {
        path: '/map/pointcash',
        name: 'map-pointcash',
        component: PointCashMapView,
        meta: {
            title: 'map'
        }
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: MaintenanceView,
        meta: {
            title: 'maintenance',
        }
    },
    {
        path: '/:notFound(.*)',
        component: NotFoundView,
        meta: {
            title: 'page_not_found'
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior () {
        return {left: 0, top: 0}
    },
});

export default router;
